function bool(name: string) {
	return process.env[name]?.toLocaleLowerCase() === "true";
}

const baseConfig = {
	baseURL: process.env.REACT_APP_API_URL,
	mockRequest: bool("REACT_APP_API_MOCK"),
	mockAuth: bool("REACT_APP_BACKOFFICE_AUTH_MOCK"),
	baseURLDomain: process.env.REACT_APP_BASE_URL_DOMAIN ?? ""
};

export { baseConfig };
